module.exports = __webpack_public_path__ + "Quicksand-VariableFont_wght.f9baef8ac0d836e64864.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/fonts/Quicksand-VariableFont_wght.ttf
// module id = ../../../../../src/assets/fonts/Quicksand-VariableFont_wght.ttf
// module chunks = styles